<template>
  <main id="app">
    <router-view></router-view>
  </main>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Importamos JQuery
// const $ = require('jquery')
// Lo declaramos globalmente
// window.$ = $;

export default {
  name: 'app',
};
</script>

<style lang="scss">
@import './assets/scss/grids/grid.scss';
@import './assets/css/fonts.css';
@import './assets/scss/integration/style.scss';
  #app {
    overflow: hidden;
  }
  .content {
    display: flex;
    position: relative;
    min-height: 85vh;
  }
  .mayuscula {
    text-transform: uppercase;
  }
  .minuscula {
    text-transform: lowercase;
  }
  
  @media only screen and (max-width: 992px) {
    .content {
      display: block;
    }
  }
  .checkBoxText {
    font-size: $font-size-small;
    color: $grayShadeDark;
    font-weight: normal !important;
  }
  .app {
    background-color: #f4f4f4;
  }
  .main {
    background-color: #f4f4f4;
  }
  .body {
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
@media only screen and (max-width: 992px) {
  .app {
    background-color: #fff;
  }
  .main {
    background-color: #fff;
  }
} 
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none !important; 
    margin: 0; 
  }
  input[type=number] {
    -moz-appearance:textfield !important; /* Firefox */
}
.btnModal:hover {
    color: #fff;
  }
  .Bgc-white {
    background-color: #fff;
  }
  .custom-select.is-invalid, .form-control.is-invalid, .was-validated .custom-select:invalid, .was-validated .form-control:invalid {
    border-color: #9d1b24;
    background-color: #ffdee1
  }
  .custom-select.is-invalid:focus, .form-control.is-invalid:focus, .was-validated .custom-select:invalid, .was-validated .form-control:invalid {
    outline: #9d1b24;
  }
  .invalid-feedback {
    width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #9d1b24;
  }
  .verde {
    color: #006900;
  }
  .caution {
    color: #776000;
  }
  .danger{
    color: #9d1b24;
  }
  .Fw-bolder {
    font-weight: bolder;
  }
  .Ta-left{
    text-align: left;
  }
  .rounded {
    border-radius: 4px;
  }
  .rounded-right {
    border-radius: 0px 4px 4px 0px 
  }
  .rounded-left {
    border-radius: 4px 0px 0px 4px 
  }
  .notas {
    font-size: $font-size-small;
    color: $grayShadeDark;
    font-weight: 300;
    line-height: 1.33;
    letter-spacing: 0.4px;
  }
.icon-avanzada {
    font-size: $font-size-biglarge;
    color: $colorBase2;
}
// datepicker
.azulBase {
    color: $colorBase2;
  }
.entrada, .salida {
    display: inline-block !important;
    width: 50% !important;
    input {
      padding-left: 30px !important;
    }
  }
  .entrada, .fechaEntrada {
    input {
      border-right: 0px !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      padding-left: 30px !important;
    }
  }
  .salida, .fechaSalida {
    input {
      border-left: 0px !important;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
      padding-left: 30px !important;
    }
  }
  .dropdown-toggle::after {
    display: none;
  }
  // Iconos de busqueda
  .contenidoSearch {
    position: relative;
    .search-icons {
      position: absolute;
      right: 5px;
      margin-top: 11px;
      font-size: $font-size-exlarge;
      color: $colorBase2;
      height: 34px;
    }
  }
  // estilos de cards y elementos
  .superTitle {
    height: 26px;
    font-size: $font-size-biglarge;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: 0.4px;
    margin-bottom: $font-size-large;
    // padding-left: 15px; 
  }
  .slide {
    align-items: center;
    display: flex;
    min-height: 320px;
    justify-content: center;
  }
  .slidePromo {
    align-items: center;
    display: flex;
    height: 250px;
    justify-content: center;
    position: relative;
  }
  @media only screen and (max-width: 992px) {
    .slidePromo {
      height: auto;
    }
  }
  // Radiobuton 
  .radio {
    position: relative;
    cursor: pointer;
    line-height: 20px;
    font-size: $font-size-base;
    margin-top: 8px !important;
    height: 34px;
    display: inline-flex;
    align-items: center;
  }
  .radio .label {
    position: relative;
    display: block;
    float: left;
    margin-right: 10px;
    min-width: 18px;
    min-height: 18px;
    border: 2px solid #c8ccd4;
    border-radius: 100%;
    -webkit-tap-highlight-color: transparent;
  }
  .radio .label:after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: $colorBase2;
    transform: scale(0);
    transition: all 0.2s ease;
    opacity: 0.08;
    pointer-events: none;
  }
  .radio:hover .label:after {
    transform: scale(3.6);
  }
  input[type="radio"]:checked + .label {
    border-color: $colorBase2;
  }
  input[type="radio"]:checked + .label:after {
    transform: scale(1);
    transition: all 0.2s cubic-bezier(0.35, 0.9, 0.4, 0.9);
    opacity: 1;
  }
  .hidden {
    display: none;
  }
  .moneda {
    font-weight: normal;
  }
  @media only screen and (max-width: 992px) {
    .radio {
      height: 40px;
    }
  }
  // avanzada
  .table th, .table td {
    white-space: nowrap;
}
// Elipse
.descripcionElipse{
      display: block;
      display: -webkit-box;
      // height: 60px;
      line-height: 1.4;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
// Cancelar Aceptar de checked
.puntero {
    font-size: 14px;
    font-weight: 500;
    color: $colorBase2;
}
.deshabilitado {
    color: $grayBrownish !important;
} 
// botones de modales
.botonesSoloadultos {
  height: 36px !important;
}
@media only screen and (max-width: 992px) {
  .botonesSoloadultos {
    height: 40px !important;
  }
}
.cursor {
  cursor: pointer;
}
</style>
